import { CommonModule } from "@angular/common";
import { Component, output } from "@angular/core";
import { CloseButton } from "@components/close-button/close-button";
import { FullScreenButton } from "@components/fullscreen-button/fullscreen-button";
import { SettingsButton } from "@components/settings-button/settings-button";

@Component({
  selector: "app-header",
  imports: [CommonModule, CloseButton, FullScreenButton, SettingsButton],
  template: `
    <div class="header">
      <div class="header__side header__side--left">
        <app-close-button (closed)="quitExerciser.emit()" />
      </div>
      <div class="header__center">
        <ng-content />
      </div>
      <div class="header__side header__side--right">
        <div class="header__desktop-only">
          <app-fullscreen-button />
        </div>
        <app-settings-button />
      </div>
    </div>
  `,
  styles: `
    @use "responsive" as *;

    .header {
      width: 100%;
      display: grid;
      grid-template-columns: 56px minmax(0, 1fr) 56px;
      align-items: center;
      margin: 0 auto 28px auto;
      flex-shrink: 0;
      gap: 18px;

      @include screenWidth("from-desktop") {
        grid-template-columns: 130px minmax(0, 1fr) 130px;
      }
    }

    .header__side {
      display: flex;
      align-items: center;
    }

    .header__side--left {
      justify-content: flex-start;
    }

    .header__side--right {
      justify-content: flex-end;
      gap: 18px;
    }

    .header__center {
      min-width: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .header__desktop-only {
      display: none;

      @include screenWidth("from-desktop") {
        display: flex;
      }
    }

    ::ng-deep .header__logo-link {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
    }
  `,
})
export class Header {
  quitExerciser = output<void>();
}
